<div class="thumb" [class.dpad-zone-start]="dstart" [class.dpad-start]="dstart && isShowsPage"
     (keydown)="handleKeyDown($event)" (keyup)="handleKeyUp($event)" #thumb tabindex="0" (focus)="focused.emit()"
     dpadSelectable [scrollTo]="true" [scrollTypeVertical]="isSeasonBanner ? 'center' : 'top'"
     [scrollPaddingVertical]="isSeasonBanner ? 0 : undefined" [class.hover]="showOptions">

    <img *ngIf="newVideo" class="thumb-new" src="{{config.remoteConfig.new_badge}}" alt="New Video"/>
    <div class="thumb-container m-2" [class.show-details-width]="isShowDetailsPage">

        <a class="thumb-link" [routerLink]="routerLink" [queryParams]="{seasonId:seasonId}">

            <div class="image-wrapper" [class.vertical]="thumbnailType === 'vertical'">
                <div>
                    <picture>
                        <source *ngIf="this.media && this.media.image && width > 0" srcset="{{this.media.image + '?width=250'}}">
                        <img class="thumb-image"
                             src="{{config.remoteConfig.loading_packshot}}" alt="Loading Image"/>
                    </picture>
                </div>
            </div>
            <div class="thumb-text"
                 *ngIf="!media.seasonId">
                <div class="episode-details mb-1 pt-3" [class.ml-2]="isSeasonBanner">
                    <img class="mx-1 channelBadge" height="46px" *ngIf="media.channelBadgeUrl"
                         src="{{media.channelBadgeUrl}}" alt="Channel Badge"/>
                    {{media.title}}
                </div>
                <div class="media-progress" [class.no-progress-bar]="!progress"
                     [class.isContinueWatching]="isContinueWatching">
                    <app-progress-bar [barHeight]="6" [progress]="progress" [max]="100"
                                      [class.d-none]="!progress"></app-progress-bar>
                </div>
            </div>

            <div class="media-duration" *ngIf="media.duration && !isSeasonBanner">
                {{isContinueWatching ? position + '&nbsp;/&nbsp;' + media.duration : media.duration}}
            </div>
        </a>

    </div>

    <div class="thumb-hover" *ngIf="!media.seasonId">
        <a class="a-route" [routerLink]="routerLink"
           [queryParams]="{seasonId:seasonId, t:continueWatchingSeconds}">
            <picture>
                <source *ngIf="this.thumbnailType !== 'vertical' && this.media && this.media.previewImage"
                        srcset="{{this.media.previewImage + '&width=250'}}" type="image/jpg">
                <source *ngIf="this.media && this.media.image" srcset="{{this.media.image + '?width=250'}}">
                <img class="thumb-image h-100 w-100" src="{{config.remoteConfig.loading_packshot}}"
                     alt="{{media.title}} Image"/>
            </picture>
        </a>

        <div class="thumb-text"
             *ngIf="!media.seasonId">
            <div class="episode-details mb-1 pt-3" [class.ml-2]="isSeasonBanner">
                <img class="mx-1 channelBadge" height="46px" *ngIf="media.channelBadgeUrl"
                     src="{{media.channelBadgeUrl}}" alt="Channel Badge"/>
                {{media.title}}
            </div>
            <div class="media-progress" [class.no-progress-bar]="!progress">
                <app-progress-bar [barHeight]="6" [progress]="progress" [max]="100"
                                  [class.d-none]="!progress"></app-progress-bar>
            </div>
        </div>
        <div class="media-duration" *ngIf="media.duration && isSeasonBanner">
            {{isContinueWatching ? position + '&nbsp;/&nbsp;' + media.duration : media.duration}}
        </div>

        <div class="thumb-options" *ngIf="showOptions" dpadContainerBasic>
            <div class="option-button">
              <button (click)="redirectToVideo()"
                      #playButton
                      dpadSelectable
                      (focus)="focusedElement = 'play'">
                <span class="button-text">Play Video</span>
                <span class="icon-circle">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <polygon points="7,5 7,15 15,10" fill="currentColor"/>
                  </svg>
                </span>
              </button>
            </div>

            <div class="option-button">
              <button *ngIf="!existsInPlaylist(media.id) && !addToPlaylistLoading"
                      #watchlistButton
                      dpadSelectable
                      (focus)="focusedElement = 'watchlist'"
                      (click)="addToPlaylist(media.id)">
                <span class="button-text">Add To Watchlist</span>
                <span class="icon-circle">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <line x1="10" y1="5" x2="10" y2="15" stroke="currentColor" stroke-width="2"/>
                    <line x1="5" y1="10" x2="15" y2="10" stroke="currentColor" stroke-width="2"/>
                  </svg>
                </span>
              </button>

              <button *ngIf="existsInPlaylist(media.id) && !addToPlaylistLoading"
                      #watchlistButton
                      dpadSelectable
                      (focus)="focusedElement = 'watchlist'"
                      (click)="deleteFromPlaylist(media.id)">
                <span class="button-text">Remove From Watchlist</span>
                <span class="icon-circle">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <line x1="5" y1="10" x2="15" y2="10" stroke="currentColor" stroke-width="2"/>
                  </svg>
                </span>
              </button>

              <button *ngIf="addToPlaylistLoading"
                      #watchlistButton
                      dpadSelectable
                      (focus)="focusedElement = 'watchlist'">
                <span class="button-text">Loading</span>
                <span class="icon-circle-loading icon-circle">
                    <svg xmlns="http://www.w3.org/2000/svg" height="12px" viewBox="0 -960 960 960" width="12px" fill="black"><path d="M480-516q65 0 110.5-45.5T636-672v-120H324v120q0 65 45.5 110.5T480-516ZM192-96v-72h60v-120q0-59 28-109.5t78-82.5q-49-32-77.5-82.5T252-672v-120h-60v-72h576v72h-60v120q0 59-28.5 109.5T602-480q50 32 78 82.5T708-288v120h60v72H192Z"/></svg>
                </span>
              </button>
            </div>
        </div>
    </div>
</div>
